import { StyleCard, StyleLeftCardWrapper, StyleRightCardWrapper } from './style'
import { FC } from 'react'
import Typography from '@components/typography'
import Button from '@components/button'
import Image from '@components/image'
import theme from '@utils/theme'

interface AppointmentBannerProps {
  title: string
  description?: string
  onClick?: () => void
  Img?: any
  btnTitle?: String
  bg?: keyof typeof theme.colors
}
const AppointmentBanner: FC<AppointmentBannerProps> = ({
  title,
  description,
  onClick,
  Img,
  btnTitle,
  bg,
}) => {
  return (
    <StyleCard bg={bg}>
      <StyleLeftCardWrapper>
        <Typography content={title} size={16} tc="primary" />
        {!!description && (
          <Typography content={description} size={14} tc="text" />
        )}
        {!!btnTitle && (
          <Button
            title={`${btnTitle}`}
            radius={8}
            styleButton="padding:0px 15px;font-size:12px;font-weight:300;"
            height={40}
            styleButtonWrapper="margin-top:10px;"
            onClick={onClick}
          />
        )}
      </StyleLeftCardWrapper>
      <StyleRightCardWrapper>
        {!!Img && <Image src={Img} height={200} />}
      </StyleRightCardWrapper>
    </StyleCard>
  )
}

export default AppointmentBanner
